import { lazy } from 'react';

export const RELOAD_FLAG_KEY = 'chunk-reload-attempted';

/**
 * Wraps React.lazy with automatic page reload on chunk load failure
 * (e.g. after a new deployment invalidates old chunk hashes).
 * Uses a sessionStorage flag to prevent infinite reload loops.
 */
export function lazyWithRetry(
  importFn: () => Promise<{ default: React.ComponentType<unknown> }>
) {
  return lazy(async () => {
    const hasReloaded = sessionStorage.getItem(RELOAD_FLAG_KEY);

    try {
      const module = await importFn();
      sessionStorage.removeItem(RELOAD_FLAG_KEY);
      return module;
    } catch (error) {
      if (!hasReloaded) {
        sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
        window.location.reload();
        return { default: () => null };
      }

      throw error;
    }
  });
}
